/**
 * Waits until global variable is available in Window object
 * @param {string} name - variable name
 * @param {Function} callback - callback after variable is mounted
 * @returns {void}
 */
export const waitForGlobalVariable = <V>(
  name: string,
  callback: (error: boolean | null, reference?: V) => void
) => {
  if (typeof window !== 'undefined') {
    const interval = setInterval(() => {
      if (name in window) {
        const ref: V = (window as Record<string, any>)[name];
        callback(null, ref);
        clearInterval(interval);
      }
    }, 100);
  } else {
    callback(true);
  }
};
